import { isArray } from "@glide/support";

export function getFirstElementFromArrayOrSingleElement(
    x: string[] | string | null | undefined
): string | undefined | null {
    return isArray(x) ? x[0] : x;
}
